/**
 * Smooth scroll to CTA section using scrollIntoView
 */
(function() {
  function scrollToCTA(e) {
    const href = this.getAttribute('href');
    if (!href || !href.includes('#')) return;

    // Check if this is a CTA-related anchor
    const isCTALink = href.includes('cta-main') || href === '#cta' || href === '#shop';
    if (!isCTALink) return;

    // If the CTA section isn't on the current page (e.g. a cross-page link
    // like "/#cta-main" from the Hoopfest landing page), don't swallow the
    // click — let the browser navigate normally to the target page.
    if (!document.querySelector('section.cta')) return;

    e.preventDefault();

    // Wait for images to load and layout to settle
    const performScroll = () => {
      // Find the CTA section
      const ctaSection = document.querySelector('section.cta');
      if (!ctaSection) return;
      
      // Get the product image in the CTA section
      const ctaImage = ctaSection.querySelector('.cta__img img');
      
      // Function to actually scroll
      const doScroll = () => {
        // Check if mobile or desktop
        const isMobile = window.innerWidth <= 768;
        
        if (isMobile) {
          // Mobile: scroll to top of section with header offset
          ctaSection.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
            inline: 'nearest'
          });
          
          // Adjust for header after scrollIntoView
          setTimeout(() => {
            const header = document.querySelector('.shopify-section-header, header');
            if (header) {
              const headerStyles = window.getComputedStyle(header);
              if (headerStyles.position === 'fixed' || headerStyles.position === 'sticky') {
                const headerHeight = header.offsetHeight;
                window.scrollBy({
                  top: -headerHeight - 20,
                  behavior: 'smooth'
                });
              }
            }
          }, 100);
        } else {
          // Desktop: center the section in viewport
          const rect = ctaSection.getBoundingClientRect();
          const absoluteTop = rect.top + window.pageYOffset;
          
          // Get header height
          let headerHeight = 0;
          const header = document.querySelector('.shopify-section-header, header');
          if (header) {
            const headerStyles = window.getComputedStyle(header);
            if (headerStyles.position === 'fixed' || headerStyles.position === 'sticky') {
              headerHeight = header.offsetHeight;
            }
          }
          
          // Calculate center position
          const viewportHeight = window.innerHeight;
          const sectionHeight = rect.height;
          const availableHeight = viewportHeight - headerHeight;
          const centerOffset = (availableHeight - sectionHeight) / 2;
          const scrollPosition = absoluteTop - headerHeight - Math.max(0, centerOffset);
          
          // Smooth scroll to calculated position
          window.scrollTo({
            top: scrollPosition,
            behavior: 'smooth'
          });
        }
      };
      
      // If image exists and not loaded, wait for it
      if (ctaImage && !ctaImage.complete) {
        ctaImage.addEventListener('load', doScroll, { once: true });
        // Fallback if image takes too long
        setTimeout(doScroll, 500);
      } else {
        // Image already loaded or doesn't exist
        doScroll();
      }
    };
    
    // Give the browser time to finish any pending operations
    setTimeout(performScroll, 50);
  }
  
  // Initialize when DOM is ready
  function init() {
    // Find all potential CTA links
    const ctaLinks = document.querySelectorAll('a[href*="#cta"], a[href*="#shop"], a[href*="cta-main"], a[href="#cta"], a[href="#shop"]');
    
    ctaLinks.forEach(link => {
      // Prevent iOS double-tap zoom delay
      link.style.touchAction = 'manipulation';
      
      // Single event listener for both touch and click
      link.addEventListener('click', scrollToCTA, { passive: false });
    });
  }
  
  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  // Re-run when new sections are loaded (for theme editor)
  document.addEventListener('shopify:section:load', init);
})();